import useStore from '@/store'
import axios, { AxiosRequestConfig } from 'axios'
import { useAxiosRefreshToken, redirectLogin } from './useAxios'

const url = '/api/v1/file/download'

type DownFileGet = () => ( id: number, config?: AxiosRequestConfig ) => void
export const useDownFileGet: DownFileGet = () => {
    const { accessToken, setAccessToken } = useStore( ( { accessToken, setAccessToken } ) => ( { accessToken, setAccessToken } ) )

    return async ( id, config ) => {
        const result = await axios.get( `${url}/${id}`, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            responseType: 'arraybuffer',
            timeout: 60000,
            ...config
        } ).catch( async ( { status, data } ) => {
            if( status === 401 ) {
                const reAccessToken = await useAxiosRefreshToken()
                setAccessToken( reAccessToken )

                return axios.get( `${url}/${id}`, {
                    ...config,
                    headers: {
                        'Authorization': `Bearer ${reAccessToken}`
                    }
                } ).catch( () => {
                    redirectLogin()
                    return Promise.reject()
                } )
            } else {
                return Promise.reject( data )
            }
        } )

        processDownloadFile( result )
    }
}

type DownFile = () => ( param: { id: number }, config?: AxiosRequestConfig ) => void
export const useDownFile: DownFile = () => {
    const { accessToken, setAccessToken } = useStore( ( { accessToken, setAccessToken } ) => ( { accessToken, setAccessToken } ) )

    return async ( param, config ) => {
        const result = await axios.post( url, param, {
            headers: {
                'Authorization': `Bearer ${accessToken}`
            },
            responseType: 'arraybuffer',
            ...config
        } ).catch( async ( { status, data } ) => {
            if( status === 401 ) {
                const reAccessToken = await useAxiosRefreshToken()
                setAccessToken( reAccessToken )

                return axios.post( url, param, {
                    ...config,
                    headers: {
                        'Authorization': `Bearer ${reAccessToken}`
                    }
                } ).catch( () => {
                    redirectLogin()
                    return Promise.reject()
                } )
            }else {
                return Promise.reject( data )
            }
        } )

        processDownloadFile( result )
    }
}

const processDownloadFile = ( { data, headers } ) => {
    const url = window.URL.createObjectURL( new Blob( [ data ], { type: headers[ 'content-type' ] } ) )
    const fileName = headers[ 'content-disposition' ].split( 'filename="' )[ 1 ].replace( '";', '' )
    const link = document.createElement( 'a' )
    link.href = url
    link.download = decodeURIComponent( fileName )
    link.click()
    window.URL.revokeObjectURL( link.toString() )
}